import React, { ReactElement, useEffect, useState } from 'react'
import { ContainerFormulario } from '@pages/style'
import { Row, Col, Typography, message, Button } from 'antd'
import { HeaderPage, Input } from '@components/atoms'
import { useRouter } from '@customHooks'
import { useForm } from 'react-hook-form'
import api from '@services/api'
import { SaveOutlined } from '@ant-design/icons'

export default function FormularioRegiao(): ReactElement {
  const {
    navigate,
    state,
    params: { id },
  } = useRouter<'id'>()
  const { control, reset, handleSubmit } = useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (id && state) {
      reset({ ...(state as object) })
    }
  }, [state, id])

  const onSubmit = () => {
    handleSubmit(async (values: any) => {
      setLoading(true)
      id
        ? await api
            .put(`/regiao/${id}`, {
              ...values,
              DHALT: new Date().toISOString(),
            })
            .then(() => {
              setLoading(false)
              message.success('Região atualizada com sucesso!')
              navigate('/manutencao/auxiliares/regioes')
            })
            .catch(() => setLoading(false))
        : await api
            .post('/regiao', { ...values, DHINC: new Date().toISOString() })
            .then(() => {
              setLoading(false)
              message.success('Região cadastrado com sucesso!')
              navigate('/manutencao/auxiliares/regioes')
            })
            .catch(() => setLoading(false))
    })()
  }

  return (
    <ContainerFormulario>
      <HeaderPage
        title={id ? 'Atualizar Região' : 'Nova Região'}
        onBack={() => navigate(-1)}
        extra={[
          <Button
            key='salvar'
            icon={<SaveOutlined />}
            type='primary'
            size='large'
            loading={loading}
            onClick={onSubmit}
          >
            Salvar
          </Button>,
        ]}
      />
      <form>
        <Row gutter={[12, 12]}>
          <Col span={24}>
            <Typography.Title level={5}>Descrição</Typography.Title>
            <Input
              control={control}
              name='DESCREGIAO'
              rules={{ required: 'Campo obrigatório' }}
              maxLength={45}
              showCount
            />
          </Col>
        </Row>
      </form>
    </ContainerFormulario>
  )
}
